import { DesignData } from '../types';

// The smallest gap between consecutive valid page counts, i.e. the number of
// pages one "add/remove pages" click must move to land on the next valid grid
// value. Returns 0 when there are fewer than two values (no meaningful step).
function getGridStepInPages(validPageCounts: number[]): number {
  let step = 0;
  for (let i = 1; i < validPageCounts.length; i += 1) {
    const gap = validPageCounts[i] - validPageCounts[i - 1];
    if (gap > 0 && (step === 0 || gap < step)) {
      step = gap;
    }
  }
  return step;
}

// How many spreads make up one "add/remove pages" step for this design.
//
// The step must move page_count to the next valid grid value, so the product
// can actually switch to the result. The grid comes from the ecommerce variant
// page counts when the product is sold online (`validPageCounts`), otherwise
// from the design's own `page_count_limit.increment`.
//
// Because a spread may hold one page (flat books: brochures) or two pages
// (spread books: photobooks), the number of spreads for one grid step is the
// step in pages divided by the pages per spread — e.g. a 4-page grid step is 4
// single-page spreads for a brochure but 2 two-page spreads for a photobook.
// Falls back to a single spread when no grid step is known.
function getSpreadCountForIncrement(designData: DesignData, spreadIndex: number, validPageCounts?: number[]): number {
  const stepInPages =
    validPageCounts && validPageCounts.length > 1
      ? getGridStepInPages(validPageCounts)
      : designData.page_count_limit?.increment ?? 0;
  if (!stepInPages) {
    return 1;
  }

  const pagesPerSpread = designData.spreads[spreadIndex]?.pages.length || 1;
  return Math.max(1, Math.round(stepInPages / pagesPerSpread));
}

export default getSpreadCountForIncrement;
